module.exports = __webpack_public_path__ + "img/image00011-min.0c1e14b4.jpeg";